// theme.ts
import { extendTheme, ThemeConfig } from "@chakra-ui/react";
import { cardTheme } from "./Card";
import { tagTheme } from "./Tag";

// Define the brand colors
const colors = {
  brand: {
    orange: "#f06b00",
    blue: "#0c92f1",
    grey: "#424242",
    yellow: "#fbba00",
    lightBlue: "#b6d9f2",
    green: "#5bb450",
    darkBlue: "#0862a1",
  },
};

// Define the global styles
const styles = {
  global: {
    body: {
      bg: "#fafafa",
      fontFamily: "Inter, sans-serif",
    },
  },
};

// Define the fonts
const fonts = {
  heading: "Inter, sans-serif",
  body: "Inter, sans-serif",
};

// Define the configuration
const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

// Extend the theme with component styles
const theme = extendTheme({
  colors,
  styles,
  fonts,
  config,
  components: {
    Card: cardTheme,
    Tag: tagTheme,
    Radio: {
      baseStyle: {
        container: {
          display: "flex",
          flexDirection: "row-reverse",
          alignItems: "center",
          justifyContent: "space-between",
          background: "#fafafa",
          borderRadius: "xl",
          padding: 2,
          paddingX: 4,
          minHeight: "36px",
        },
      },
      variants: {
        orange: {
          label: {
            fontSize: "var(--base-font-size-small)",
            ml: 0,
          },
          control: {
            border: "2px solid var(--color-grey-light)",
            _checked: {
              background: "var(--color-orange)",
              borderColor: "var(--color-orange)",

              _focus: {
                boxShadow: "none",
                borderColor: "var(--color-orange)",
              },
              _hover: {
                background: "var(--color-orange)",
                borderColor: "var(--color-orange)",
              },
            },
          },
        },
      },
    },

    Tabs: {
      variants: {
        unstyled: {
          text: {
            font: "Inter, sans-serif",
            fontSize: "var(--base-font-size)",
          },
          tablist: {
            background: "white",
            padding: 0,
            paddingLeft: "19px",
            width: "fit-content",
            gap: 14,
          },
          tab: {
            fontSize: "var(--base-font-size)",
            p: 0,
            width: "6px",
            _selected: {
              fontWeight: "bold",
            },
          },
          tabpanel: {
            padding: "0",
            pt: 5,
            fontSize: "var(--base-font-size-small)",
          },
        },
        softRounded: {
          text: {
            font: "Inter, sans-serif",
          },
          tablist: {
            background: "#d9d9d9",
            borderRadius: "full",
            padding: "3px 3px",
            width: "fit-content",
          },
          tab: {
            fontSize: "12px",
            padding: "3px 12px",
            _selected: {
              bg: "var(--color-grey)",
              borderRadius: "full",
              color: "white",
            },
          },
        },
      },
      sizes: {
        sm: {
          text: {
            fontSize: "12px",
          },
        },
      },
    },
    Switch: {
      variants: {
        parrotOrange: {
          track: {
            _checked: {
              bg: "var(--color-orange)",
            },
          },
        },
      },
    },
    Button: {
      variants: {
        customGhost: {
          bg: "transparent",
          border: "none",
          borderColor: "transparent",
          padding: "0",
          _hover: {
            bg: "transparent",
          },
          _active: {
            bg: "transparent",
          },
          _focus: {
            boxShadow: "none",
          },
        },
      },
    },
  },
});

export default theme;
